import styled from "styled-components";
import { fanduel } from "@fanduel/formation-tokens";

export const TopPromotionsContainer = styled.div`
  &::after {
    content: "";
    display: block;
    position: relative;
    width: 100%;
    height: var(--fd-space-space-4);
    pointer-events: none;
    background: var(--fd-colors-background-base);
  }
`;

export const FeaturedSlotsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  max-width: ${fanduel.breakpoints.desktop}px;
  min-width: 10em;

  > div:first-child {
    margin-top: 0;
  }

  @media only screen and (max-width: 699px) {
    > div:last-child {
      margin-bottom: 0;
    }
  }
`;

export const PromoSlotsWrapper = styled.div`
  display: block;
  padding: var(--fd-space-space-4) var(--fd-space-space-4) 0;
  border-radius: var(--fd-space-space-1) var(--fd-space-space-1) 0 0;
  max-width: ${fanduel.breakpoints.desktop}px;

  @media only screen and (max-width: 700px) {
    padding: var(--fd-space-space-4);
  }

  @media only screen and (min-width: 1024px) {
    min-width: ${fanduel.breakpoints.desktop}px;
  }
`;

export const HeaderContainer = styled.div`
  display: block;
  padding: var(--fd-space-space-4) var(--fd-space-space-4) 0;
`;
